<template>
  <div>
    <form-wizard>    
    </form-wizard>
  </div>
</template>

<script>
import Wizard from "@/components/steps/Wizard.vue";

export default {
  name: "Home",
  components: {
    "form-wizard": Wizard
  }
};
</script>
